import { SUPRA_MAINNET_CHAIN_ID, SUPRA_TESTNET_CHAIN_ID } from './chains'

const tokens = {
  core: {
    symbol: 'ETH',
    projectLink: 'https://ethereum.org/',
  },
  bow: {
    symbol: 'TOON',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0x12605027AF4A482BE2799dD8F38F095Aa093CCC4',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 18,
    projectLink: 'https://toonswap.xyz/',
  },
  xbow: {
    symbol: 'xTOON',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0xd021178dF92542185942FaE6b4266CC6092a00e7',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 18,
    projectLink: 'https://toonswap.xyz/',
  },
  wcore: {
    symbol: 'WETH',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 18,
    projectLink: 'https://ethereum.org/',
  },
  usdc: {
    symbol: 'USDC',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 6,
    projectLink: 'https://www.centre.io/',
  },
  usdt: {
    symbol: 'USDT',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 6,
    projectLink: 'https://tether.to/',
  },
  wbtc: {
    symbol: 'WBTC',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 8,
    projectLink: 'https://wbtc.network/',
  },
  supra: {
    symbol: 'SUPRA',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0xDC7404100A092c898E93708EF73F3322A7acc213',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 18,
    projectLink: 'https://supra.com/',
  },
  pepe: {
    symbol: 'PEPE',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0x6982508145454Ce325dDbE47a25d4ec3d2311933',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 18,
    projectLink: 'https://www.pepe.vip/',
  },
  paw: {
    symbol: 'PAW',
    address: {
      [SUPRA_MAINNET_CHAIN_ID]: '0x5555dd68e459c7b29e774D702Fd121d5528E6c75',
      [SUPRA_TESTNET_CHAIN_ID]: '',
    },
    decimals: 18,
    projectLink: 'https://supaw.gitbook.io/supaw',
  },
}

export default tokens
